import React from 'react';
import {connect} from 'react-redux';

import {editComment, onChangeEditComment, setUpdatingComment, updateCommentChange} from './../../../../redux/actions';
import {PrimaryButton, SecondaryButton} from "@sfly/uig-button";
import likesCommentOmnitureCalls from './../../../../redux/utils/likeCommentOmnitureCalls';

import helpers from './../../../../components/utils/helper';

class EditCommentBy extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            comment: '',
            autoGrow: true,
            rows: 1
        }
    }

    componentDidMount() {
        const element = document.getElementById("edit-comment-Id");
        if (element) {
            element.focus();
            element.selectionStart = this.props.comments.editComment.commentText.length;
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.autoGrow && nextProps.comments.editComment && nextProps.comments.editComment.commentText && nextProps.comments.editComment.id != this.props.comments.editComment.id) {
            this.autoGrow();
            const element = document.getElementById("edit-comment-Id");
            element.focus();
            element.selectionStart = nextProps.comments.editComment.commentText.length;
        }
        this.props = nextProps;
    }

    onEdit = () => {
        likesCommentOmnitureCalls.callOmniture('share-product:edit comment canceled');
        this.props.onEdit(false);
    }

    onChange = (evt) => {
        this.props.onChangeEditComment(evt.target.value);
        this.autoGrow();
    }

    onKeyDown = (event) => {
        if (event.which === 13 && !event.shiftKey) {
            event.preventDefault();
            this.editComment(event);
            return;
        }
    }

    editComment = (event) => {
        event.preventDefault();
        if (!this.props.comments.editComment.commentText || (!this.props.comments.editComment.commentText.replace(/ /g, ''))) {
            return;
        }
        var body = this.props.comments.editComment;
        body.userId = this.props.user.userId;
        body.family_name = this.props.user.family_name;
        body.given_name = this.props.user.given_name;
        body.email = this.props.user.email;

        this.props.editComment(this.props.comments.editComment, this.props.originalSharedProjectGuid);
        likesCommentOmnitureCalls.callOmniture('share-product:edit comment saved');
    }

    autoGrow() {
        // this.setState({
        //     autoGrow: false
        // });
        var height = document.getElementById("edit-comment-Id").scrollHeight;
        var rows = Math.floor(height / 21);
        console.log('height', height);
        if (rows > 4) rows = 4;
        if (this.state.rows !== rows) {
            this.setState({
                rows
            })
        }
    }

    getRows = () => {
        return helpers.isMobile() ? 4 : this.state.rows;
    }

    render() {
        return (<div className="edit-comment-container" onSubmit={this.editComment}>
                <form className="add-comment-form row">
                    <div className="add-comment  col-xs-8">
                        <textarea
                            type="text"
                            value={this.props.comments.editComment.commentText}
                            onChange={this.onChange}
                            rows={this.getRows()}
                            id="edit-comment-Id"
                            onKeyDown={this.onKeyDown}/>
                    </div>
                    <div className="button-container col-xs-4">
                        <div className="row display-flex">
                            <div className="col-xs-12 col-sm-6 col-lg-6 col-md-6">
                                <SecondaryButton onClick={this.onEdit}>
                                    Cancel
                                </SecondaryButton>
                            </div>
                            <div className="marginTop10  col-sm-6 col-lg-6 col-md-6">
                                <PrimaryButton onClick={this.editComment}>
                                    Done
                                </PrimaryButton>
                            </div>
                        </div>

                    </div>
                </form>

            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        comments: state.comments
    };
};

export default connect(mapStateToProps, {
    onChangeEditComment,
    updateCommentChange,
    editComment,
    setUpdatingComment
})(EditCommentBy);